import styled from 'styled-components'

export const ModuleWrapper = styled.div`
  margin: 8rem 0;
`

export const Title = styled.h2`
  color: ${p => p.theme.colors.black[1]};
  font-size: 2rem;
  font-weight: 900;
  text-align: center;
`

export const SliderWrapper = styled.div`
  overflow: hidden;
  padding: 1rem 0;
  margin: 2rem 0 1rem;

  .swiper {
    overflow: visible;
    margin: 0 -0.5rem;
    max-width: 50rem;
  }

  .swiper-slide {
    height: auto;
    padding: 0 0.5rem;
    width: 50%;

    @media screen and (max-width: 820px) {
      width: 100%;
      max-width: 24rem;
    }
  }
`

export const SliderInner = styled.div`
  margin: 0 auto;
  max-width: 48rem;

  @media screen and (max-width: 820px) {
    max-width: 80vw;
  }
`

export const Slide = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: 24rem;

  & > * {
    height: 100%;
  }
`

export const SliderNavigation = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  justify-items: center;
`
